import styled from "styled-components";

export const ContractUploadContainer = styled.div`
    padding-left: 64px;
    padding-bottom: 20px;
`;
